"use client";
import Progress from "@/components/NProgress";
import Footer from "@/components/ui/Footer";
import dynamic from "next/dynamic";
const HeaderContainer = dynamic(
  () => import("@/components/ui/Header/header1"),
  { ssr: false }
);

import "animate.css";
import "bootstrap/scss/bootstrap.scss";
import localFont from "next/font/local";
import { useEffect } from "react";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./globals.scss";
import { Providers } from "./providers";

const soraFont = localFont({
  src: "../../public/fonts/sora/Sora-Regular.otf",
  style: "normal",
});

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    const color = localStorage.getItem("color") || "color-1";
    document.documentElement.classList.remove(color);
    localStorage.setItem("color", "color-1");
    document.documentElement.classList.add("color-1");
  }, []);
  return (
    <html lang="es" className={soraFont.className}>
      <head>
        <link rel="icon" href="/images/icon.png" />
        <link rel="shortcut icon" href="/images/icon.png" />
        <link rel="apple-touch-icon" href="/images/icon.png" />

        <meta name="version" content="0.0.8" />
      </head>
      <body>
        <Progress />
        <Providers>
          <div>
            <HeaderContainer display="d-none" />
          </div>
          {children}
          <Footer />
        </Providers>
      </body>
    </html>
  );
}
